import React from "react";

const AddressForm = ({ formData, errors, handleChange, handleSubmit, showSameAsDelivery = false }) => {
  return (
    <form onSubmit={handleSubmit}>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
        <div>
          <label htmlFor="title" className="block text-gray-dark mb-1">Adres Başlığı</label>
          <input
            type="text"
            id="title"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className={`w-full p-2 border rounded-md focus:outline-none focus:ring-1 ${
              errors.title ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-primary"
            }`}
          />
          {errors.title && <p className="text-red-500 text-sm mt-1">{errors.title}</p>}
        </div>
        <div>
          <label htmlFor="state" className="block text-gray-dark mb-1">İlçe</label>
          <input
            type="text"
            id="state"
            name="state"
            value={formData.state}
            onChange={handleChange}
            className={`w-full p-2 border rounded-md focus:outline-none focus:ring-1 ${
              errors.state ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-primary"
            }`}
          />
          {errors.state && <p className="text-red-500 text-sm mt-1">{errors.state}</p>}
        </div>
      </div>

      <div className="mb-6">
        <label htmlFor="address" className="block text-gray-dark mb-1">Adres</label>
        <textarea
          id="address"
          name="address"
          value={formData.address}
          onChange={handleChange}
          rows={3}
          className={`w-full p-2 border rounded-md focus:outline-none focus:ring-1 ${
            errors.address ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-primary"
          }`}
        />
        {errors.address && <p className="text-red-500 text-sm mt-1">{errors.address}</p>}
      </div>

      {showSameAsDelivery && (
        <div className="mb-6">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="is_same_as_delivery"
              checked={formData.is_same_as_delivery ?? true}
              onChange={handleChange}
              className="mr-2"
            />
            Teslimat adresiyle aynı
          </label>
        </div>
      )}

      {/* Eğer teslimat adresiyle aynı değilse, ek alanları göster */}
      {showSameAsDelivery && !formData.is_same_as_delivery && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6 border-t pt-4 mt-4">
          <div>
            <label className="block mb-1">Ad Soyad</label>
            <input
              type="text"
              name="full_name"
              value={formData.full_name || ""}
              onChange={handleChange}
              className={`w-full p-2 border rounded-md focus:outline-none focus:ring-1 ${
                errors.full_name ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-primary"
              }`}
            />
            {errors.full_name && <p className="text-red-500 text-sm mt-1">{errors.full_name}</p>}
          </div>
          <div>
            <label className="block mb-1">İlçe (Fatura)</label>
            <input
              type="text"
              name="billing_state"
              value={formData.billing_state || ""}
              onChange={handleChange}
              className={`w-full p-2 border rounded-md focus:outline-none focus:ring-1 ${
                errors.billing_state ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-primary"
              }`}
            />
            {errors.billing_state && <p className="text-red-500 text-sm mt-1">{errors.billing_state}</p>}
          </div>
          <div className="sm:col-span-2">
            <label className="block mb-1">Adres (Fatura)</label>
            <textarea
              name="billing_address"
              rows={3}
              value={formData.billing_address || ""}
              onChange={handleChange}
              className={`w-full p-2 border rounded-md focus:outline-none focus:ring-1 ${
                errors.billing_address ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-primary"
              }`}
            />
            {errors.billing_address && <p className="text-red-500 text-sm mt-1">{errors.billing_address}</p>}
          </div>
          <div>
            <label className="block mb-1">Vergi Numarası</label>
            <input
              type="text"
              name="tax_number"
              value={formData.tax_number || ""}
              onChange={handleChange}
              className={`w-full p-2 border rounded-md focus:outline-none focus:ring-1 ${
                errors.tax_number ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-primary"
              }`}
            />
            {errors.tax_number && <p className="text-red-500 text-sm mt-1">{errors.tax_number}</p>}
          </div>
          <div>
            <label className="block mb-1">Vergi Dairesi</label>
            <input
              type="text"
              name="tax_office"
              value={formData.tax_office || ""}
              onChange={handleChange}
              className={`w-full p-2 border rounded-md focus:outline-none focus:ring-1 ${
                errors.tax_office ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-primary"
              }`}
            />
            {errors.tax_office && <p className="text-red-500 text-sm mt-1">{errors.tax_office}</p>}
          </div>
        </div>
      )}

    </form>
  );
};

export default AddressForm;
